import React from 'react';
import { LoadingPage } from '../../Components/LoadingOverlay';
import { UnexpectedError } from '../Shared';
import { useDashboardPageViewModel } from './hooks/viewModel/useDashboardPageViewModel';
import { DashboardTabsView } from './components/DashboardTabsView';

export const BeaconPage = () => {
  const vm = useDashboardPageViewModel();

  if (vm.status === 'loading') {
    return <LoadingPage />;
  }

  if (vm.status === 'error') {
    return <UnexpectedError message={vm.errorMessage} />;
  }

  return (
    <DashboardTabsView
      dashboards={vm.dashboards}
      activeTabKey={vm.activeTabKey}
      onTabChange={vm.onTabChange}
    />
  );
};
